export enum TopicUsersAutocompleteType {
  User,
  Manager
}
